module.exports = "/static/media/webcam_icon.0d4c3e6b.svg";